var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 240.028,
    height: 298.172,
    viewBox: "0 0 63.507 78.891",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "matrix(39.03276 0 0 -39.03276 3602.812 1974.39)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#31ecff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567,
    style: {
      stopOpacity: 1,
      stopColor: "#0373ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    style: {
      stopOpacity: 1,
      stopColor: "#0373ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#0373ff"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    x2: 1,
    y1: 0,
    y2: 0,
    gradientTransform: "scale(-101.78187 101.78187) rotate(-70 -3.415 35.784)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopOpacity: 1,
      stopColor: "#31ecff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.561,
    style: {
      stopOpacity: 1,
      stopColor: "#0373ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.803,
    style: {
      stopOpacity: 1,
      stopColor: "#0373ff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopOpacity: 1,
      stopColor: "#0373ff"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2160h3840V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M63.507 78.891H0V0h63.507z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.383485
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    style: {
      display: "inline"
    },
    transform: "matrix(.44962 0 0 -.44962 -1596.905 937.635)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.122.121-.183.334-.031.517l2.31 2.644c.122.152.304.152.456.03 1.368-1.094 3.222-2.127 5.41-2.127 2.158 0 3.374 1.002 3.374 2.462 0 1.215-.729 1.975-3.191 2.309l-1.095.153C3.039 6.565.699 8.54.699 12.187c0 3.8 2.857 6.323 7.325 6.323 2.735 0 5.289-.821 7.021-2.158.182-.122.213-.244.061-.456l-1.854-2.767c-.122-.151-.274-.182-.426-.09-1.58 1.033-3.1 1.58-4.802 1.58-1.824 0-2.766-.942-2.766-2.249 0-1.185.851-1.945 3.221-2.279l1.095-.153c4.255-.577 6.505-2.522 6.505-6.261 0-3.738-2.766-6.503-8.116-6.503C4.741-2.826 1.61-1.55 0 0",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3571.624 1935.2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 .182.122.303.304.303h13.251c.183 0 .305-.121.305-.303v-3.252c0-.183-.122-.304-.305-.304H4.65c-.122 0-.182-.061-.182-.183v-4.103c0-.122.06-.182.182-.182h7.416c.182 0 .304-.122.304-.304v-3.222c0-.182-.122-.304-.304-.304H4.65c-.122 0-.182-.061-.182-.182v-4.286c0-.121.06-.182.182-.182h8.905c.183 0 .305-.122.305-.303v-3.253c0-.182-.122-.304-.305-.304H.304c-.182 0-.304.122-.304.304Z",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3590.103 1953.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 1.55-1.094 2.553-2.796 2.553h-3.647c-.122 0-.183-.061-.183-.183v-4.772c0-.121.061-.182.183-.182h3.647C-1.094-2.584 0-1.581 0 0m.334-14.254c-.273 0-.365.09-.456.304l-3.556 7.567h-2.765c-.122 0-.183-.06-.183-.182v-7.385c0-.183-.122-.304-.304-.304h-3.86c-.182 0-.304.121-.304.304V6.109c0 .182.122.304.304.304h8.237c4.224 0 7.02-2.644 7.02-6.413 0-2.645-1.398-4.742-3.677-5.745l4.073-8.145c.09-.182 0-.364-.213-.364z",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3617.761 1946.963)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 .182.122.303.304.303h3.86c.183 0 .304-.121.304-.303v-20.06c0-.182-.121-.304-.304-.304H.304c-.182 0-.304.122-.304.304Z",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3625.025 1953.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0 .182.121.303.304.303h13.251c.183 0 .305-.121.305-.303v-3.252c0-.183-.122-.304-.305-.304H4.65c-.121 0-.182-.061-.182-.183v-4.103c0-.122.061-.182.182-.182h7.416c.182 0 .304-.122.304-.304v-3.222c0-.182-.122-.304-.304-.304H4.65c-.121 0-.182-.061-.182-.182v-4.286c0-.121.061-.182.182-.182h8.905c.183 0 .305-.122.305-.303v-3.253c0-.182-.122-.304-.305-.304H.304c-.183 0-.304.122-.304.304Z",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3632.836 1953.072)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-2.34 7.234h-.091L-4.772 0Zm-4.65 12.644c.061.181.182.303.395.303h3.83c.213 0 .334-.122.394-.303l6.99-20.06c.062-.183 0-.304-.212-.304H2.796c-.213 0-.334.091-.394.304L1.216-3.8h-7.234l-1.155-3.616c-.061-.213-.182-.304-.395-.304h-3.982c-.213 0-.273.121-.213.304z",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3666.178 1940.428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3571.952 1925.119h33.586v-7.589h-33.586z",
    style: {
      fill: "#00a445",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3605.539 1925.119h33.586v-7.589h-33.586z",
    style: {
      fill: "#e3e3e2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3639.125 1925.119h33.586v-7.589h-33.586z",
    style: {
      fill: "#db052c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 19.514 51.531L27.94 29.28H17.302l-7.255-19.16h25.149L39.028 0Z",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3602.817 1990.353)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 50.379 31.925H19.514Zm0 0-50.379 31.925h30.865z",
    style: {
      fill: "#1a1659",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(3622.331 1958.428)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3602.812 1990.353 19.519-31.926 19.514 31.926z",
    style: {
      fill: "url(#b)",
      stroke: "none"
    },
    transform: "matrix(.44962 0 0 -.44962 -1596.905 937.635)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3608.416 2075.266-36.464-84.914h30.865l19.514 51.532 8.426-22.251h-10.637l-7.256-19.161h25.149l3.832-10.12h30.865l-36.464 84.914z",
    style: {
      fill: "url(#c)",
      stroke: "none"
    },
    transform: "matrix(.44962 0 0 -.44962 -1596.905 937.635)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSa);
export default __webpack_public_path__ + "static/media/sa.4c3f106bc957cc0ce065a152c5a9ef35.svg";
export { ForwardRef as ReactComponent };